import { Send } from "lucide-react";
import Logo from "@/components/Logo";
import { openCookiePreferences } from "@/components/CookieBanner";
import { scrollToId } from "@/lib/ui";
import { TELEGRAM_URL, SITE } from "@/config";

const NAV = [
    { id: "come-funziona", label: "Come funziona" },
    { id: "offerte", label: "Offerte" },
    { id: "perche-noi", label: "Perché noi" },
    { id: "faq", label: "FAQ" },
];

const LEGAL = [
    { href: "/privacy", label: "Privacy Policy" },
    { href: "/cookie-policy", label: "Cookie Policy" },
    { href: "/termini", label: "Termini e Condizioni" },
    { href: "/disclaimer", label: "Disclaimer" },
    { href: "/affiliazione", label: "Affiliazione e trasparenza" },
];

export default function Footer() {
    return (
        <footer data-testid="footer" className="grain relative bg-[#070C15] text-white">
            <div className="relative z-10 mx-auto max-w-7xl px-4 pb-10 pt-16 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
                    <div>
                        <Logo light />
                        <p className="mt-4 max-w-xs text-[15px] leading-relaxed text-white/60">
                            {SITE.tagline}
                        </p>
                        <a
                            href={TELEGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-telegram-cta"
                            className="mt-6 inline-flex items-center gap-2 rounded-full bg-telegram px-5 py-3 text-sm font-bold text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-telegram-glow hover:shadow-[0_16px_36px_-10px_rgba(34,158,217,0.6)]"
                        >
                            <Send className="h-4 w-4" />
                            Entra su Telegram
                        </a>
                    </div>

                    <div>
                        <h4 className="font-mono text-[11px] font-bold uppercase tracking-[0.22em] text-white/40">
                            Naviga
                        </h4>
                        <ul className="mt-5 space-y-3">
                            {NAV.map((l) => (
                                <li key={l.id}>
                                    <button
                                        onClick={() => scrollToId(l.id)}
                                        data-testid={`footer-link-${l.id}`}
                                        className="text-[15px] text-white/70 transition-colors duration-300 hover:text-telegram-glow"
                                    >
                                        {l.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-mono text-[11px] font-bold uppercase tracking-[0.22em] text-white/40">
                            Informazioni
                        </h4>
                        <ul className="mt-5 space-y-3">
                            {LEGAL.map((l) => (
                                <li key={l.href}>
                                    <a
                                        href={l.href}
                                        data-testid={`footer-link${l.href.replace(/\//g, "-")}`}
                                        className="text-[15px] text-white/70 transition-colors duration-300 hover:text-telegram-glow"
                                    >
                                        {l.label}
                                    </a>
                                </li>
                            ))}
                            <li>
                                <button
                                    onClick={openCookiePreferences}
                                    data-testid="footer-cookie-preferences"
                                    className="text-[15px] text-white/70 underline decoration-white/25 underline-offset-4 transition-colors duration-300 hover:text-telegram-glow"
                                >
                                    Preferenze cookie
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 border-t border-white/10 pt-8">
                    <p
                        className="mx-auto max-w-3xl text-center text-xs leading-relaxed text-white/40"
                        data-testid="footer-disclaimer"
                    >
                        Amazon e il logo Amazon sono marchi di Amazon.com, Inc. o delle sue affiliate.
                        Sconti Incredibili non è affiliato, sponsorizzato o approvato da Amazon, salvo
                        diversa indicazione.
                    </p>
                    <p className="mt-5 text-center font-mono text-[11px] tracking-wide text-white/30">
                        © {new Date().getFullYear()} Sconti Incredibili · Tutti i diritti riservati
                    </p>
                </div>
            </div>
        </footer>
    );
}
